module.exports = __webpack_public_path__ + "img/Storage=Category-Off.cbf8cb5d.svg";